import {MapLayers, MapModes} from './MapPage.types';

export const LOCAL_STORAGE_MAP_LAYERS_KEY = 'LOCAL_STORAGE_MAP_LAYERS_KEY';
export const LOCAL_STORAGE_BC_LAYERS_KEY = 'LOCAL_STORAGE_BC_LAYERS_KEY';
export const LOCAL_STORAGE_CURRENT_BC_LAYERS_KEY =
  'LOCAL_STORAGE_CURRENT_BC_LAYERS_KEY';

export const getInitialLayers = (type: MapModes) => (): MapLayers => {
  let key: string;

  switch (type) {
    case MapModes.default:
      key = LOCAL_STORAGE_MAP_LAYERS_KEY;
      break;
    case MapModes.departmentControl:
      key = LOCAL_STORAGE_BC_LAYERS_KEY;
      break;
    case MapModes.currentRegion:
      key = LOCAL_STORAGE_CURRENT_BC_LAYERS_KEY;
      break;
  }

  const cachedLayers = localStorage.getItem(key);

  if (cachedLayers) return JSON.parse(cachedLayers);

  const res: MapLayers = {
    DEPARTMENTS: {
      active: false,
      title: 'Предприятия (парки)',
    },
    ROUTES: {
      active: false,
      title: 'Маршруты',
    },
    STOPS: {
      active: true,
      title: 'Остановки',
    },
    VEHICLES: {
      title: 'Транспортные средства',
      active: false,
    },
  };

  if (type === MapModes.default) {
    res.AGENCIES = {
      active: false,
      title: 'Филиалы'
    }
  }

  if (type !== MapModes.default) {
    res.BCREGIONS = {
      active: true,
      title: 'Районы контроля',
    };
    delete res.DEPARTMENTS;
    res.BC_DEP = {
      active: false,
      title: 'Территориальные отделы',
    };
  }

  if (type === MapModes.departmentControl) {
    res.STOPS.active = false;
  }

  if (type === MapModes.currentRegion) {
    res.STOPS.active = true;
    res.ROUTES.active = true;
  }

  return res;
};
